import { ChartBuilder } from 'Molecules/InsightsChart/chartBuilder';
import { ChartType } from '../chartTypes';
import { BarChartData } from 'Molecules/InsightsChart/chartBuilder';
import { BaseInsightPayload } from '../InsightDataPayload';
import { InsightChartFactory } from '../insightChartFactory';
import { parseProjectsBusinessUnitPayload } from '../payloads/projectsBusinessUnitPayload';
import DefaultChartWithTrendSupport from 'Molecules/InsightsChart/DefaultChartWithTrendSupport';
import { groupDataByCategory } from '../utils/dataGrouping';
import { getProjectStatusGroupLegendName } from '../utils/legendLocalizationHelper';
import intl from 'react-intl-universal';

export const buildProjectsBusinessUnitInsightFactory = (
  payload: BaseInsightPayload
): InsightChartFactory => {
  const parsedPayload = parseProjectsBusinessUnitPayload(payload);
  const rawData = parsedPayload.data.attributes.data;

  return (props) => {
    // Use the generic data grouping utility
    const { transformedData, uniqueCategories } = groupDataByCategory({
      rawData,
      groupKey: 'business_unit_id',
      displayField: 'business_unit_title',
      categoryField: 'project_status_group',
      valueField: 'project_count',
    });

    // Create field names, legend names, and stacks
    const xAxisFieldNames = uniqueCategories;
    const legendNames = uniqueCategories.map(getProjectStatusGroupLegendName);
    const stacks = new Array(uniqueCategories.length).fill('projects');

    const chart = new ChartBuilder()
      .setChartType(ChartType.H_BAR_STACK)
      .setProps({
        chartData: transformedData as BarChartData,
        onDrillDown: props.onDrillDown,
        yAxisFieldName: 'business_unit_title',
        xAxisFieldNames,
        legendNames,
        stacks,
        barAxisName: intl.get('INSIGHT.AXIS.NUMBER_OF_PROJECTS'),
        yAxisName: intl.get('INSIGHT.AXIS.BUSINESS_UNITS'),
      })
      .build();

    return DefaultChartWithTrendSupport({
      chartComponent: chart,
    });
  };
};
